import { useQueryClient } from "react-query";
import AllChats from "src/views/assistant/components/splashScreen/AllChats";
import { useSetWorkflowRecentsConfig } from "../hooks/useWorkflowProductConfig";
import type { WorkflowProductDescriptor } from "../types";

/** A workflow product's dialogue-history page: AllChats scoped to the product. */
const WorkflowRecentsPage = ({
  product,
}: {
  product: WorkflowProductDescriptor;
}) => {
  const queryClient = useQueryClient();

  // Set product configuration with buildChatUrl for resolving row links
  useSetWorkflowRecentsConfig(product, queryClient);

  return <AllChats />;
};

export default WorkflowRecentsPage;
